import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { Analysis, RequestUser, AnalysisRemove } from "../../models/models";
import { RefdataProvider } from '../../providers/refdata/refdata'
import { BhutilProvider } from '../../providers/bhutil/bhutil';

@Injectable({
    providedIn: 'root'
})
export class AnalysisServiceProvider {

  //TODO = move baseUrl and headers to some kind of config.
  private baseUrl = '';
  private headers = new HttpHeaders({
    "x-api-key": "Key1SV0ce45i4Dhrob6VP74IWR45IqRb2wVur7rx",
    "Content-Type": "application/json"
  });
  private options = { headers: this.headers };

  private _analysisId: String;
  private _beerId: String;
  private _lastPage: String;
  private _prevPage: String;

  constructor(public http: HttpClient, private refdata: RefdataProvider, private bhutil: BhutilProvider) {
    this.baseUrl = this.refdata.getEnvVar('apiBaseUrl');
    this._lastPage = "none";
  }

  getAnalysisId(): String {
    return this._analysisId;
  }

  setAnalysisId(analysisId: String) {
    this._analysisId = analysisId;
  }

  getBeerId(): String {
    return this._beerId;
  }

  setBeerId(beerId: String) {
    this._beerId = beerId;
  }

  getLastPage(): String {
    return this._lastPage;
  }

  setLastPage(lastPage: String) {
    // store prev page
    let prevPage = this.getLastPage();
    this.setPrevPage(prevPage);
    this._lastPage = lastPage;
  }

  getPrevPage(): String {
    return this._prevPage;
  }

  setPrevPage(prevPage: String) {
    this._prevPage = prevPage;
  }

  httpPost(url: string, payLoad: any, readableName: string) {
    return this.http.post(url, payLoad, this.options).pipe(
      timeout(30000),
//      map((res: Response) => res.json()),
      catchError((error: any) => {
          if (error && error.error && typeof error.error === 'object' && error.error.message) {
              return throwError(() => new Error(`Server error: ${error.error.message}`));
          } 
          return throwError(() => new Error("Server error: Could not retrieve " + readableName));
      })
    );

  }

  getStats(user: RequestUser) {
    let endpoint = "/stats";
    return this.httpPost(this.baseUrl + endpoint, user, endpoint)
  }

  removeAnalysis(removeItem: AnalysisRemove) {
    let endpoint = "/deleteanalysis";
    return this.httpPost(this.baseUrl + endpoint, removeItem, endpoint)
  }

  addAnalysis(analysis: Analysis) {
    let endpoint = "/addanalysis";

    let realAnalysis: any = {};
    //add all items from analysis, except characteristics
    realAnalysis["userid"] = analysis.userid;
    realAnalysis["user_id"] = analysis.user_id;
    realAnalysis["latitude"] = analysis.latitude;
    realAnalysis["longitude"] = analysis.longitude;
    realAnalysis["beer_id"] = analysis.beer_id;

    //check for presence of "notes"
    if (analysis.notes !== undefined && analysis.notes != null && analysis.notes.length > 0) {
      console.log("[analysis-service] addAnalysis - also adding notes!");
      realAnalysis["notes"] = analysis.notes;
    }

    this.setSpiderValues(analysis, realAnalysis);

    realAnalysis["colour"] = analysis.colour;

    //totalexperience
    if (analysis.totalexperience !== undefined && analysis.totalexperience != null && analysis.totalexperience != -1) {
      //console.log("[analysis-service] addAnalysis - also adding totalexperience!");
      ////debugger;
      realAnalysis["totalexperience"] = analysis.totalexperience;//WAS totalexperience
    }

    //add all values for characeristics
    for (let characteristic of analysis.characteristicsvalues) {
      let charKey = characteristic.name;
      let charValue = characteristic.value;
      realAnalysis[charKey] = charValue;
    }

    let jsonValue = this.bhutil.stringify(realAnalysis);
    console.log("[ADDANALYSIS] request params: " + jsonValue);

    let r = this.httpPost(this.baseUrl + endpoint, realAnalysis, endpoint)
    return r;
  }

  updateAnalysis(analysis: Analysis, shouldSendEmptyNotes: boolean) {

    let endpoint = "/updateanalysis";

    let realAnalysis: any = {};
    //add all items from analysis, except characteristics
    realAnalysis["userid"] = analysis.userid;
    realAnalysis["user_id"] = analysis.user_id;
    realAnalysis["latitude"] = analysis.latitude;
    realAnalysis["longitude"] = analysis.longitude;
    realAnalysis["beer_id"] = analysis.beer_id;
    realAnalysis["id"] = analysis.id;

    //check for presence of "notes"
    if (analysis.notes !== undefined && analysis.notes != null && analysis.notes.length > 0) {
      console.log("[analysis-service] updateAnalysis - also adding notes!");
      realAnalysis["notes"] = analysis.notes;
    }
    // ADDED FOR BEERHIVE-216
    if(shouldSendEmptyNotes) {
      realAnalysis["notes"] = "";
    }
    this.setSpiderValues(analysis, realAnalysis);

    if (analysis.colour) realAnalysis["colour"] = analysis.colour;
    if (analysis.intensity) realAnalysis["intensity"] = analysis.intensity;
    if (analysis.body) realAnalysis["body"] = analysis.body;
    if (analysis.astringent) realAnalysis["astringent"] = analysis.astringent;
    if (analysis.alcohol) realAnalysis["alcohol"] = analysis.alcohol;
    if (analysis.carbonation) realAnalysis["carbonation"] = analysis.carbonation;

    //totalexperience
    if (analysis.totalexperience !== undefined && analysis.totalexperience != null && analysis.totalexperience != -1) {
      //console.log("[analysis-service] updateAnalysis - also adding totalexperience!");
      ////debugger;
      realAnalysis["totalexperience"] = analysis.totalexperience;//WAS totalexperience
    }

    //add all values for characeristics
    for (let characteristic of analysis.characteristicsvalues) {
      let charKey = characteristic.name;
      let charValue = characteristic.value;
      let charIndex = charKey.indexOf("_");
      /*if(charIndex != -1) {
        if(charValue != 0)
          realAnalysis[charKey] = charValue;
      }
      else {*/
      realAnalysis[charKey] = charValue;
      //}

    }

    //debugger;

    let jsonValue = this.bhutil.stringify(realAnalysis);
    console.log("[UPDATEANALYSIS] request params: " + jsonValue);

    let r = this.httpPost(this.baseUrl + endpoint, realAnalysis, endpoint);
    return r;
  }

  setSpiderValues(inputAnalysis: any, targetAnalysis: any) {
    let spiderParameters = ['sweet', 'sour', 'bitter', 'malty', 'fruity', 'hoppy'];

    spiderParameters.forEach((value, index) => {
      targetAnalysis[value] = (inputAnalysis[value] != -1 ? inputAnalysis[value] : null);
    });
  }

  getMyAnalyses(user: RequestUser, pageNumber: number, rowCount: number, sortFilter: any, venueId: Number) {
    let endpoint = "/myanalyses";
    let body = {};
    body['userid'] = user.userid;
    body['latitude'] = user.latitude;
    body['longitude'] = user.longitude;
    body['pageNumber'] = pageNumber;
    body['rowCount'] = rowCount;
    body['direction'] = sortFilter.direction;
    body['sortField'] = sortFilter.sortField;
    body['venueId'] = venueId;
    return this.httpPost(this.baseUrl + endpoint, body,endpoint);
  }

}
